/** Testable browser navigation helpers (avoids non-configurable `window.location` in unit tests). */

export const browserNavigation = {
	assignWindowLocation(url: string): void {
		window.location.href = url;
	},
};

export function assignWindowLocation(url: string): void {
	browserNavigation.assignWindowLocation(url);
}
